<ion-header class="ion-header-free-trail">
  <ion-toolbar>
    <div class="header-grid">
      <div class="main-logo-sec">
        <img src="assets/images/eZintegration-black-logo.svg">
      </div>
    </div>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="signup-container">
    <div class="signup-bg-grid">
      <!-- <img class="bg" src="assets/images/signUp-bg.png" alt=""> -->
      <div class="bg-content-grid">
        <div class="company-logo-sec">
          <a target="_blank" id="signup_bizdata_logo" href="https://www.bizdata360.com/">
            <img src="assets/images/bizdata-welcome-logo.svg">
          </a>
        </div>
        <div class="views-content">
          <span class="content-1"> Real Time Cloud Based Integration Platform </span>
          <span class="content-2"> No-code, a browser-based cloud integration platform that can connect any system and
            integrate data from different sources </span>
        </div>
        <div class="views-btn-demo">
          <a href="https://www.youtube.com/watch?v=CypbpT_vhoE?rel=0" target="_blank"><img class="img-demo"
              src="assets/images/onboard.svg"></a>
          <button mat-raised-button class="watch-demo" id="signup_onboard"><a class="watch-demo-a"
              href="https://www.youtube.com/watch?v=CypbpT_vhoE?rel=0" target="_blank">Onboard</a></button>
        </div>
        <div class="views-img">
          <img src="assets/images/signUp-side-img.png">
        </div>
      </div>
    </div>
    <div class="signup-content-grid">
      <div class="grid-content">
        <div class="signup-viewgrid">
          <div class="main-logo-sec">
            <a target="_blank" id="signup_ezintegration_logo"
              href="https://www.bizdata360.com/ezintegrations-business-integration-platform/">
              <img src="assets/images/bizdata-welcome-logo.svg">
            </a>
          </div>
          <mat-card>
            <mat-card-content>
              <div class="signup-sec">
                Start Free Trial
              </div>
              <div class="form-container">
                <form [formGroup]="signupform" (ngSubmit)="onSubmit()">
                  <div class="form-layout">
                    <mat-form-field appearance="outline">
                      <mat-label>First name</mat-label>
                      <input type="text" id="signup_firstname" formControlName="firstName" matInput
                        placeholder="First name" required>
                      <!-- <mat-error *ngIf="submitted && f.firstName.hasError('required')">First Name Required. </mat-error> -->
                      <mat-error *ngIf="signupform.get('firstName').hasError('pattern')">
                        First Name Allows Alphanumeric Only!
                      </mat-error>
                      <mat-error *ngIf="signupform.get('firstName').hasError('required')">
                        First Name is Required!
                      </mat-error>
                    </mat-form-field>
                    <!-- <mat-error style="color: red;" *ngIf="signupform.controls['firstName'].invalid && (signupform.controls['firstName'].dirty || signupform.controls['firstName'].touched)">Please correct foo entry !</mat-error> -->
                    <mat-form-field appearance="outline">
                      <mat-label>Last name</mat-label>
                      <input type="text" id="signup_lastname" formControlName="lastName" matInput
                        placeholder="Last name" required>
                      <mat-error *ngIf="signupform.get('lastName').hasError('pattern')">
                        Last Name Allows Alphanumeric Only!
                      </mat-error>
                      <mat-error *ngIf="signupform.get('lastName').hasError('required')">
                        Last Name is Required!
                      </mat-error>
                      <!-- <mat-error *ngIf="submitted && f.lastName.hasError('required')">Last Name Required. </mat-error> -->
                    </mat-form-field>
                  </div>
                  <div class="form-layout">
                    <mat-form-field appearance="outline">
                      <mat-label>Work email Address</mat-label>
                      <input type="text" id="signup_work_email" formControlName="email" matInput
                        placeholder="Work email Address" required>
                      <!-- <mat-error *ngIf="submitted && f.email.hasError('required')">Work email Required. </mat-error> -->
                      <mat-error *ngIf="submitted && f.email.hasError('email')">Email must be Valid. </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Phone number</mat-label>

                      <!-- <span matPrefix>+91 &nbsp;&nbsp;</span> -->
                      <input type="text" id="signup_phone" minlength="10" maxlength="18" formControlName="phone"
                        matInput placeholder="Phone number" required>
                      <!-- <mat-error *ngIf="submitted && f.phone.hasError('required')">Phone number Required. </mat-error> -->

                      <!-- <mat-error *ngIf="signupform.get('phone').hasError('pattern')">
                        Please Enter a Valid Phone Number
                      </mat-error> -->
                      <mat-error *ngIf="signupform.get('phone').hasError('required')">
                        Phone Number is Required!
                      </mat-error>
                      <mat-error *ngIf="signupform.get('phone').hasError('minlength')">
                        <!-- Minimum length should be 10 digits -->
                        Please Enter a Valid 10 digit Phone Number
                      </mat-error>
                      <mat-error *ngIf="signupform.get('phone').hasError('maxlength')">
                        Maximum length should be 18 digits
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="form-layout">
                    <mat-form-field appearance="outline">
                      <mat-label>Job Title</mat-label>
                      <mat-select formControlName="jobTitle" id="signup_job" required>
                        <mat-option>-- Select --</mat-option>
                        <mat-option *ngFor="let job of jobTitle" [value]="job">{{job.name}}</mat-option>
                      </mat-select>
                      <!-- <mat-error *ngIf="submitted && f.jobTitle.hasError('required')">Job Title Required. </mat-error> -->
                    </mat-form-field>
                    <mat-form-field appearance="outline" *ngIf="showempcom">
                      <mat-label>Employee</mat-label>
                      <mat-select formControlName="employee" id="signup_employee">
                        <mat-option>-- Select --</mat-option>
                        <mat-option *ngFor="let emp of employee" value="{{emp.name}}">{{emp.name}}</mat-option>
                      </mat-select>
                      <!-- <mat-error *ngIf="submitted && f.employee.hasError('required')">Employee Required. </mat-error> -->
                    </mat-form-field>
                    <mat-form-field appearance="outline" *ngIf="!showempcom">
                      <mat-label>Country</mat-label>
                      <mat-select formControlName="country" id="signup_country" required>
                        <mat-option>-- Select --</mat-option>
                        <mat-option *ngFor="let country of countries"
                          value="{{country.country_name}}">{{country.country_name}}</mat-option>
                      </mat-select>
                      <!-- <mat-error *ngIf="submitted && f.country.hasError('required')">Country Required. </mat-error> -->
                    </mat-form-field>
                  </div>
                  <div class="form-layout">
                    <mat-form-field appearance="outline" *ngIf="showempcom">
                      <mat-label>Company</mat-label>
                      <input type="text" formControlName="company" id="signup_company" maxlength="40" matInput
                        placeholder="Company">
                      <mat-error *ngIf="signupform.get('company').hasError('pattern')">
                        Pleae enter a valid Company Name!
                      </mat-error>
                      <mat-error *ngIf="signupform.get('company').hasError('required')">
                        Company Name is Required!
                      </mat-error>
                      <!-- <mat-error *ngIf="companyNameError"></mat-error> -->
                      <!-- <mat-error *ngIf="companyNameError">Pleae enter a valid company name.</mat-error> -->
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="showempcom">
                      <mat-label>Country</mat-label>
                      <mat-select formControlName="country" required>
                        <mat-option>-- Select --</mat-option>
                        <mat-option *ngFor="let country of countries"
                          value="{{country.country_name}}">{{country.country_name}}</mat-option>
                      </mat-select>
                      <!-- <mat-error *ngIf="submitted && f.country.hasError('required')">Country Required. </mat-error> -->
                    </mat-form-field>
                  </div>
                  <div class="links-grid">
                    <mat-checkbox formControlName="agreeSubscription" id="signup_checkbox" required>I agree to the <a
                        style="text-decoration: none;" class="signin-link" target="_blank"
                        href="https://www.bizdata360.com/master-subscription-agreement.pdf">Master Subscription
                        Agreement</a></mat-checkbox>
                    <mat-error *ngIf="submitted && f.agreeSubscription.hasError('required')">Please accept Master
                      subscription. </mat-error>
                    <p>By registering you confirm that agree to storing and processing of your personal data by Bizdata
                      as described in the <a style="text-decoration: none;" id="signup_privacy_statement"
                        target="_blank" href="https://www.bizdata360.com/privacy-policy/">privacy statement</a></p>
                  </div>
                  <div class="btn-signup-grid">
                    <button mat-raised-button type="submit" id="signup_submit" class="btn-signup">START MY FREE
                      TRIAL</button>
                  </div>
                  <div style="text-align: center;"><span>-------------------- or --------------------</span></div>
                </form>
                <div class="btn-signup-grid">
                  <button class="btn-signin-teams" mat-stroked-button (click)="checkMSALLogedIn()">
                      <div style="display: flex;">
                        <div style="margin-right: 10px;">
                          <img height="20px" width="20px" src="../../../assets/images/Microsoft_logo.svg" alt="logo">
                        </div>
                        <div>
                          <span style="font-size: 16px;font-weight: 350;">Continue with Microsoft Login</span>
                        </div>
                      </div>
                  </button>
                  <!-- <button class="btn-signin-teams" mat-stroked-button id="login_github">
                    <span style="margin-top:2px">
                      <div style="float: left;margin-right:4px">
                        <img height="20px" width="20px" src="../../../assets/images/GitHub-Logo.wine.svg" alt="logo">
                      </div>
                      <span>Continue with GitHub Account</span>
                    </span>
                  </button> -->
                </div>
                <div class="back-login">
                  <p>Return to <a class="signin-link" id="signup_signin"
                      style="text-decoration: none; font-weight: 500;" routerLink="/login" href="javascript:void(0)">
                      Sign in </a></p>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
        <app-powered-by-footer></app-powered-by-footer>
      </div>
    </div>
  </div>
  <div class="container">
    <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
    <router-outlet *ngIf="!isIframe"></router-outlet>
  </div>
</ion-content>